import { BookmarkCircleIcon } from "@/components/icons/bookmark-circle-icon";
import { SmileIcon } from "@/components/icons/smile-icon";
import ImageWithLoading from "@/components/image/image-with-loading";
import { cn } from "@/utils/cn";
import { memo } from "react";

interface PlanOverviewImageProps {
  imageUri: string;
  name: string;
  notLikeable: boolean;
  imageHasWhiteBackground: boolean;
}

export const PlanOverviewImage = memo(function PlanOverviewImage({
  imageUri,
  name,
  notLikeable,
  imageHasWhiteBackground,
}: PlanOverviewImageProps) {
  return (
    <div
      className={cn("relative h-[460px] min-h-[320px] w-full flex-shrink-0", {
        "bg-white pt-22": imageHasWhiteBackground,
      })}
    >
      <ImageWithLoading
        src={imageUri}
        alt={name}
        classNames={{
          container: cn("h-full w-full overflow-hidden object-cover", {
            "bg-gray-300": !imageHasWhiteBackground,
            "bg-white": imageHasWhiteBackground,
          }),
          image: cn("h-full w-full object-cover", {
            "scale-[0.84]": imageHasWhiteBackground,
          }),
        }}
        notFoundImage={
          notLikeable ? (
            <BookmarkCircleIcon className="h-16.5 w-16.5" />
          ) : (
            <SmileIcon className="h-16.5 w-16.5" />
          )
        }
        errorImage={
          notLikeable ? (
            <BookmarkCircleIcon className="h-16.5 w-16.5" />
          ) : (
            <SmileIcon className="h-16.5 w-16.5" />
          )
        }
      />
      {/* 
      <div
        className={cn(
          "pointer-events-none absolute right-0 -bottom-0 left-0 z-20 h-20 bg-gradient-to-b from-transparent to-white",
        )}
      /> */}
    </div>
  );
});
